import { useEffect, useRef, useState } from "react"
import {
  AddIngredientButton,
  IngredientList,
  Label,
  Placeholder,
  StyledIngredients,
  StyledSwipeAction,
} from "./styled"
import PlusIcon from "components/Icons/PlusIcon"
import { FoodListDivider } from "components/foodItem/FoodListItem/styled"
import { SwipeActionRef } from "antd-mobile"
import TrashIcon from "components/Icons/TrashIcon"
import EdamaIngredientItem from "components/foodItem/EdamaIngredientItem"
import { IEdamaIngredientOption } from "model/food/types/edama.types"

interface FoodItemProps {
  food: IEdamaIngredientOption
  swipedId: any
  setSwipedId: (id: any) => void
  onRemove: () => void
  onViewDetails: (food: IEdamaIngredientOption) => void
}

const SwipeFoodItem = (props: FoodItemProps) => {
  const { food, swipedId, setSwipedId, onRemove, onViewDetails } = props

  useEffect(() => {
    if (swipedId && swipedId !== food.uuid) {
      ref.current?.close()
    }
  }, [swipedId])

  const ref = useRef<SwipeActionRef>(null)

  return (
    <StyledSwipeAction
      closeOnTouchOutside={false}
      ref={ref}
      onActionsReveal={(value) => {
        setSwipedId(food.uuid)
      }}
      closeOnAction={false}
      rightActions={[
        {
          key: "delete",
          text: <TrashIcon />,
          color: "danger",
          onClick: onRemove,
        },
      ]}
    >
      {" "}
      <EdamaIngredientItem
        food={food}
        hideAddBtn={true}
        style={{ paddingLeft: 8, paddingRight: 8 }}
        onSelect={(food) => onViewDetails(food)}
        hasArrow={true}
      />
    </StyledSwipeAction>
  )
}

interface IProps {
  ingredients: IEdamaIngredientOption[]
  showSearchIngredients: () => void
  onRemoveIngredient: (id: string) => void
  onViewIngredientDetails: (ingredient: IEdamaIngredientOption) => void
}

const EdamaIngredients = (props: IProps) => {
  const {
    ingredients,
    showSearchIngredients,
    onRemoveIngredient,
    onViewIngredientDetails,
  } = props
  const [swipedId, setSwipedId] = useState<any>(null)
  return (
    <StyledIngredients>
      <Label>Ingredients</Label>

      <AddIngredientButton
        onClick={showSearchIngredients}
        fill="outline"
        style={{
          "--border-color": "#0da3ba",
        }}
      >
        <PlusIcon />
        Add Ingredients
      </AddIngredientButton>
      {!ingredients.length && (
        <Placeholder>Add ingredients to calculate your nutrition</Placeholder>
      )}

      {ingredients.length ? (
        <IngredientList>
          {ingredients.map((food, index: number) => (
            <div key={food.uuid}>
              <SwipeFoodItem
                onViewDetails={() => onViewIngredientDetails(food)}
                food={food}
                swipedId={swipedId}
                setSwipedId={setSwipedId}
                onRemove={() => onRemoveIngredient(food.uuid)}
              />
              {index !== ingredients.length - 1 && <FoodListDivider />}
            </div>
          ))}
        </IngredientList>
      ) : null}
    </StyledIngredients>
  )
}

export default EdamaIngredients
